<template>
    <div v-if="idDocExpire !== 'all'">
        <div class="modal-body">
            <div class="row gutters">
                <div class="col-12">
                    <div class="form-group">
                        <label for="daysExpire" class="required">{{ t('DOCUMENTS.CRESCENT_DAY') }}:</label>
                        <input type="number" id="daysExpire" @change="limitDate" placeholder="Dias para acrescentar" v-model="numberDays" class="form-control"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <div class="d-flex flex-row">
                <button class="btn btn-secondary mr-1" @click="$emit('closeModal')">Fechar</button>
                <button class="btn btn-primary" @click="save">Salvar</button>
            </div>
        </div>
    </div>
    <div v-else>
        <div class="modal-body">
            <div class="row gutters">
                <div class="col-12">
                    <div class="form-group">
                        <label for="daysExpire" class="required">{{ t('DOCUMENTS.CRESCENT_DAY') }}:</label>
                        <input type="number" id="day" @change="limitDate" placeholder="Dias para acrescentar" v-model="numberDays" class="form-control"/>
                    </div>
                </div>
                <div class="col-12 mb-2">
                    <div class="dropdown-divider"></div>
                    <div class="text-center font-weight-bolder" style="color: #0e5e4e">
                        Somente documentos que irão expirar entre:
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group">
                        <label for="start" class="required">{{ t('DOCUMENTS.PLUS_START_DATE') }}:</label>
                        <input type="date" id="start" placeholder="expirando entre inicio"
                               v-model="start_date" class="form-control"
                               @change="verifyDate('start')"
                        />
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group">
                        <label for="end" class="required">{{ t('DOCUMENTS.PLUS_END_DATE') }}:</label>
                        <input type="date" id="end" placeholder="expirando entre final"
                               @change="verifyDate('end')"
                               v-model="end_date" class="form-control"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <div class="d-flex flex-row">
                <button class="btn btn-secondary mr-1" @click="$emit('closeModal')">Fechar</button>
                <button class="btn btn-primary" @click="save">Salvar</button>
            </div>
        </div>
    </div>
</template>

<script>
import {useI18n} from 'vue-i18n';
import {useToast} from 'vue-toastification';
import {mapActions} from 'vuex';
import moment from 'moment';

export default {
    name: "modalPlusTimeExpirationComponent",
    setup() {
        const {t} = useI18n();
        const toast = useToast();
        return {t, toast}
    },
    props:['idDocExpire'],
    data() {
        return {
            numberDays: null,
            start_date: moment().format('YYYY-MM-DD'),
            end_date: moment().add(1, 'days').format('YYYY-MM-DD'),
        }
    },
    emits:['closeModal'],
    methods:{
        ...mapActions({
            plusSingleDocumentExpiration:'plusSingleDocumentExpiration',
            plusAllDocumentExpiration:'plusAllDocumentExpiration',
        }),
        verifyDate(context)
        {
            if (context === 'start'){
                if (this.end_date && this.start_date > this.end_date){
                    this.start_date = this.end_date;
                    this.toast.error("Data inicial deve ser menor ou igual a data final");
                }else if (moment(this.start_date).diff(moment().format('YYYY-MM-DD'), 'days') > 90){
                    this.start_date = moment().format('YYYY-MM-DD');
                    this.toast.error("Data inicial deve conter data inferior a 90 dias a partir de hoje");
                }else if (moment(this.start_date).isBefore(moment(), 'day')){
                    this.start_date = moment().format('YYYY-MM-DD');
                    this.toast.error("Data inicial deve conter data superior ou igual a hoje");
                }
            }
            if (context === 'end'){
                if (this.start_date && this.end_date < this.start_date){
                    this.end_date = this.start_date;
                    this.toast.error("Data final deve ser maior ou igual a data inicial");
                }else if (moment(this.end_date).diff(moment().format('YYYY-MM-DD'), 'days') > 90){
                    this.end_date = moment().add(90, 'days').format('YYYY-MM-DD');
                    this.toast.error("Data final deve conter data inferior a 90 dias a partir de hoje");
                }else if (moment(this.end_date).isBefore(moment(), 'day')){
                    this.end_date = moment().add(90, 'days').format('YYYY-MM-DD');
                    this.toast.error("Data final deve conter data superior ou igual a hoje");
                }
            }
        },
        limitDate()
        {
            if (this.numberDays > 90){
                this.numberDays = 90;
            }
        },
        validationFields()
        {
            let valid = true;
            if (!this.numberDays){
                valid = false;
                this.toast.error('Necessario informar dias para acrescentar!')
            }else if (this.numberDays < 1 || this.numberDays > 90){
                valid = false;
                this.toast.error('Campo acrescentar dias deve conter valor entre 1 e 90');
            }
            if (this.idDocExpire === 'all'){
                if (!this.end_date || !this.start_date){
                    this.toast.error("Campo Data inicial e data final são obrigatórios");
                    return false
                }
                if (moment(this.end_date).isBefore(moment(), 'day')){
                    valid = false;
                    this.toast.error("Data final deve conter data superior ou igual a hoje");
                }
                if (moment(this.start_date).isBefore(moment(), 'day')){
                    valid = false;
                    this.toast.error("Data inicial deve conter data superior ou igual a hoje");
                }
                if (moment(this.end_date).diff(moment().format('YYYY-MM-DD'), 'days') > 90){
                    valid = false;
                    this.toast.error("Data final deve conter data inferior a 90 dias a partir de hoje");
                }
                if (moment(this.start_date).diff(moment().format('YYYY-MM-DD'), 'days') > 90){
                    valid = false;
                    this.toast.error("Data inicial deve conter data inferior a 90 dias a partir de hoje");
                }
                if (this.end_date < this.start_date){
                    valid = false;
                    this.toast.error("Data final deve ser maior ou igual a data inicial");
                }
            }
            return valid;
        },
        save(){
            if (this.validationFields()){
                if (this.idDocExpire === 'all'){
                    this.plusAllDocumentExpiration({day:this.numberDays, start_date:this.start_date, end_date:this.end_date});
                }else {
                    this.plusSingleDocumentExpiration({day:this.numberDays, item:this.idDocExpire});
                }
            }
        },
    }
}
</script>

<style scoped>

</style>
